import React from 'react'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'
import useMediaQuery from '@mui/material/useMediaQuery'

type Props = {
  isRendering: boolean
  elevation?: number
  // Bottom edge (px, relative to the map) of the filter-chips stack. When the
  // chips are present the pill sits just below them so it stays at the top of
  // the map without overlapping the chips; otherwise it uses its default top.
  chipsBottom?: number
}

const TOP_GAP = 12

const MapLoadingProgress: React.FC<Props> = ({
  isRendering,
  elevation,
  chipsBottom = 0,
}) => {
  const isMobile = useMediaQuery('(max-width: 600px)')
  const top = chipsBottom > 0 ? chipsBottom + TOP_GAP : isMobile ? 68 : 16
  return (
    <Card
      elevation={elevation || 4}
      sx={{
        position: 'absolute',
        top,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 10000,
        minWidth: 140,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        userSelect: 'none',
      }}
    >
      <CardContent
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          padding: '12px 16px !important',
        }}
      >
        <CircularProgress
          size={20}
          thickness={5}
          sx={{ color: isRendering ? 'lightblue' : 'darkblue' }}
        />
        <Typography variant="body2">Loading...</Typography>
      </CardContent>
    </Card>
  )
}

export default MapLoadingProgress
